import React from 'react'
import Div from '@jumbo/shared/Div'

const ActiveReportFooter = () => {
    return <Div>{/*<h1>I am Active report footer</h1>*/}</Div>
}

export default ActiveReportFooter
